import React, { useEffect, useState, useMemo } from "react";
import Navbar from "../../Navbar";
import {
  Container,
  Typography,
  ListItemIcon,
  Button,
  Tooltip,
  MenuItem,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { Delete } from "@mui/icons-material";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MarcarActivoMotivo from "./activo/MarcarActivoMotivo";
import { getData } from "../../../services/library";
import AltaMotivoNoCompra from "./alta/AltaMotivoNoCompra";
import BajaMotivoNoCompra from "./baja/BajaMotivoNoCompra";
import EdicionMotivoNoCompra from "./edicion/EdicionMotivoNoCompra";
import DescriptionIcon from '@mui/icons-material/Description';

function MotivosNoCompra() {
  const [motivos, setMotivos] = useState(); //aca se almacenan los datos que me trae la api
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [tabla, setTabla] = useState(true); //Estado q mostrará o no la tabla (pantalla inicial) dnd estan los clientes
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [baja, setBaja] = useState(false); //Abre formulario
  const [dataMotivo, setDataMotivo] = useState({});
  const [marcarActivo, setMarcarActivo] = useState(false);

  //Tabla
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);

  //  Funcion para traer los clientes a la tabla : ACTIVOS
  const obtenerMotivosInactivos = () => {
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    getData("/envasado_motivos_nocompra/inactivos", setMotivos);
  };

  //Funcion para traer los clientes a la tabla TODOS :ACTIVOS E INACTIVOS
  const obtenerMotivos = () => {
    setHiddenmuestraactivos(true);
    setHiddenmuestrainactivo(false);
    getData("/envasado_motivos_nocompra/", setMotivos);
  };

  useEffect(() => {
    obtenerMotivos();
  }, [tabla]);

  const handleClickNuevo = () => {
    setAlta(true);
  };

  const handleCloseEditar = () => {
    setEditar(false);
    setTabla(true);
    obtenerMotivos();
  };
  const handleCloseAlta = () => {
    setAlta(false);
    setTabla(true);
    obtenerMotivos();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id", //access nested data with dot notation
        header: "ID",
        maxSize: 100,
      },
      {
        accessorKey: "descripcion", //access nested data with dot notation
        header: "Motivo",
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      //   maxSize: 5, //set custom width
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
        // maxSize: 5, //set custom width
      },
    },
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 1 }}>
        {tabla && (
          <MaterialReactTable
            localization={MRT_Localization_ES}
            columns={columns}
            data={motivos ?? [{}]}
            layoutMode={"grid"}
            initialState={initialState}
            enableColumnActions={false} //deshabilita las acciones POR COLUMNA
            enableGlobalFilterModes={false}
            enableHiding={false}
            enableRowActions={true}
            enableColumnFilters={false}
            enableFullScreenToggle={false}
            positionActionsColumn={"last"}
            enableExpandAll={false}
            enableToolbarInternalActions={true}
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            enableDensityToggle={false}
            displayColumnDefOptions={displayColumnDefOptions}
            enableColumnResizing={true}
            muiTableBodyCellProps={({ row }) => ({
              align: "left",
              sx: {
                backgroundColor:
                  row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
                color: "black",
                // borderColor: "black",
              },
            })}
            renderTopToolbarCustomActions={() => (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddBoxTwoToneIcon color="asd" />}
                  onClick={handleClickNuevo}
                >
                  Nuevo Motivo
                </Button>
                <Typography variant="poster" fontSize={26}>
                  <DescriptionIcon sx={{ fontSize: 20 }} />
                  Motivos de "No Compra"
                </Typography>
              </>
            )}
            renderToolbarInternalActions={() => (
              <>
                {!hiddenmuestrainactivo ? (
                  <Tooltip title="Muestra Inactivos">
                    <IconButton
                      onClick={() => obtenerMotivosInactivos()}
                      color="error"
                    >
                      <PersonOffIcon />
                    </IconButton>
                  </Tooltip>
                ) : null}
                {!hiddenmuestraactivos ? (
                  <Tooltip title="Mostrar ACTIVOS" color="success">
                    <IconButton onClick={() => obtenerMotivos()}>
                      <PersonIcon />
                    </IconButton>
                  </Tooltip>
                ) : null}
              </>
            )}
            renderRowActionMenuItems={({ closeMenu, row, index }) => [
              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? null : "none",
                }}
                disabled={row.original.activo === 1}
                onClick={() => {
                  setMarcarActivo(true);
                  setDataMotivo(row.original);
                  closeMenu();
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <CheckCircleOutlineIcon color="success" />
                </ListItemIcon>
                Marcar Activo
              </MenuItem>,

              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? "none" : null,
                }}
                disabled={row.original.activo === 0}
                onClick={() => {
                  closeMenu();
                  setDataMotivo(row.original);
                  setEditar(true);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <BorderColorIcon color="primary" />
                </ListItemIcon>
                Editar
              </MenuItem>,

              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? "none" : null,
                }}
                disabled={row.original.activo === 0}
                onClick={() => {
                  closeMenu();
                  setDataMotivo(row.original);
                  setBaja(true);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <Delete color="error" />
                </ListItemIcon>
                Marcar Inactivo
              </MenuItem>,
            ]}
          />
        )}

        {baja && (
          <BajaMotivoNoCompra
            open={baja}
            setOpen={setBaja}
            motivo={dataMotivo}
            tabla={setTabla}
            actualizar={obtenerMotivos}
          />
        )}
        {editar ? (
          <EdicionMotivoNoCompra
            editar={editar}
            datosRow={dataMotivo}
            onClose={() => handleCloseEditar(false)}
          />
        ) : null}
        {alta ? (
          <AltaMotivoNoCompra alta={alta} onClose={() => handleCloseAlta(false)} />
        ) : null}
        {marcarActivo ? (
          <MarcarActivoMotivo
            open={marcarActivo}
            setOpen={setMarcarActivo}
            motivo={dataMotivo}
            tabla={setTabla}
            actualizar={obtenerMotivos}
          />
        ) : null}
      </Container>
    </>
  );
}

export default MotivosNoCompra;
